export default __webpack_public_path__ + "static/media/completed.10226d7f.png";